import { Action, action } from "easy-peasy";

export interface AdminModalsModel {
  showSupportModal: boolean;
  showContactSalesModal: boolean;

  setShowSupportModal: Action<AdminModalsModel, boolean>;
  setShowContactSalesModal: Action<AdminModalsModel, boolean>;
}

export const modals: AdminModalsModel = {
  showSupportModal: false,
  showContactSalesModal: false,

  setShowSupportModal: action((state, payload: boolean) => {
    state.showSupportModal = payload;
  }),
  setShowContactSalesModal: action((state, payload: boolean) => {
    state.showContactSalesModal = payload;
  }),
};
